// Shrine spawn + tier configuration.
//
// These values are intentionally centralized so you can tune the shrine system
// without digging through map generation or UI code.

// The earliest floor a shrine can appear on.
// Example: set to 5 if you want shrines to start spawning from floor 5 onward.
export const SHRINE_MIN_FLOOR = 5;

// Per-floor chance that EXACTLY ONE shrine attempt is made.
// (If placement fails due to map constraints, no shrine will appear.)
export const SHRINE_SPAWN_CHANCE_PER_FLOOR = 0.45;

// Tier distribution for a spawned shrine. Must sum to 1.0 (or close).
export const SHRINE_TIER_WEIGHTS = {
  common: 0.8,
  rare: 0.15,
  mythic: 0.05,
};

// Payment configuration (effects/reward list can be expanded later).
export const SHRINE_COMMON_COST_AMOUNT = 1;
export const SHRINE_COMMON_COST_KINDS = ['teeth', 'key', 'potion', 'torch'];

// Rare shrine sacrifices MAX stats. Amount is subtracted from maxHp/maxSp.
export const SHRINE_RARE_COST_AMOUNT = 5;
export const SHRINE_RARE_COST_KINDS = ['maxHp', 'maxSp'];

// Mythic shrine sacrifices are always deck cards (picked by the player).
export const SHRINE_MYTHIC_COST_KIND = 'deckCard';
export const SHRINE_MYTHIC_COST_AMOUNT = 1;

export function rollShrineTier(rng, weights = SHRINE_TIER_WEIGHTS) {
  const wC = Number(weights?.common ?? 0);
  const wR = Number(weights?.rare ?? 0);
  const wM = Number(weights?.mythic ?? 0);
  const total = Math.max(0.000001, wC + wR + wM);
  const x = (typeof rng === 'function' ? rng() : Math.random()) * total;
  if (x < wC) return 'common';
  if (x < wC + wR) return 'rare';
  return 'mythic';
}
